import ClicksDetector from "./ClicksDetector";
import UserTracking from "./UserTracking";
import ElementsTracking from "./ElementsTracking";
import CSRFManager from "./CSRFManager";

export default (function() {
  function run() {
    UserTracking.run();
    ClicksDetector.run();
    ElementsTracking.run();
    CSRFManager.run();
  }

  return {
    run: run
  };
})();
